import React, { useEffect, useState } from 'react';
import { api } from '../lib/api';

/**
 * cywerstudio.com/play — a porta do jogador. Lista os jogos PUBLICADOS (GET /api/public/ugc/games)
 * e deixa lançar cada um. É a "cara" web da plataforma; o jogo em si corre no runtime (app Cywer).
 *
 * MVP: catálogo público. Login/personalização e o deep-link real da app entram a seguir.
 */
export default function PlayPage() {
  const [games, setGames] = useState(null); // null = a carregar
  const [err, setErr] = useState(null);

  useEffect(() => {
    api.get('/public/ugc/games')
      .then((d) => setGames(d.games || []))
      .catch((e) => setErr(e.detail || 'Não foi possível carregar os jogos.'));
  }, []);

  function jogar(g) {
    // Deep-link para a app instalada (modelo Roblox). A app regista o esquema cywerstudio://
    // e abre o jogo por id. Enquanto a app não estiver instalada, o browser ignora — por isso
    // mostramos também o id para lançar à mão no runtime.
    window.location.href = `cywerstudio://play/${g.id}`;
  }

  return (
    <div className="cs-play">
      <style>{CSS}</style>

      <header className="cs-play-hd">
        <div className="cs-play-brand">Cywer <b>Studio</b></div>
        <a className="cs-play-link" href="/estudio">Criar um jogo →</a>
      </header>

      <main className="cs-play-main">
        <h1>Jogar</h1>
        <p className="cs-play-sub">Jogos criados pela comunidade, a correr no mesmo runtime.</p>

        {err && <div className="cs-play-msg cs-bad">{err}</div>}
        {!err && games === null && <div className="cs-play-msg">A carregar…</div>}
        {!err && games && games.length === 0 && (
          <div className="cs-play-msg">Ainda não há jogos publicados. Sê o primeiro — <a href="/estudio">cria um</a>.</div>
        )}

        {games && games.length > 0 && (
          <div className="cs-grid">
            {games.map((g) => (
              <div className="cs-card" key={g.id}>
                <div className="cs-thumb" aria-hidden>🍳</div>
                <div className="cs-card-body">
                  <div className="cs-card-name">{g.name || 'Sem nome'}</div>
                  <div className="cs-card-author">por {g.author || 'anónimo'}</div>
                  <button className="cs-btn" onClick={() => jogar(g)}>Jogar</button>
                  <div className="cs-id">id: {g.id}</div>
                </div>
              </div>
            ))}
          </div>
        )}
      </main>
    </div>
  );
}

const CSS = `
.cs-play{--bg:#0e1014;--panel:#171a21;--line:#2a2f3a;--ink:#e6e9ef;--muted:#8b93a4;--accent:#f39a33;--bad:#e2564a;
  min-height:100vh;background:var(--bg);color:var(--ink);font:15px/1.5 system-ui,Segoe UI,Roboto,sans-serif}
.cs-play a{color:var(--accent);text-decoration:none}
.cs-play-hd{display:flex;align-items:center;justify-content:space-between;padding:16px 24px;border-bottom:1px solid var(--line)}
.cs-play-brand{font-size:18px;letter-spacing:.5px}
.cs-play-brand b{color:var(--accent)}
.cs-play-main{max-width:1000px;margin:0 auto;padding:32px 24px}
.cs-play-main h1{font-size:30px;margin:0}
.cs-play-sub{color:var(--muted);margin:6px 0 24px}
.cs-play-msg{background:var(--panel);border:1px solid var(--line);border-radius:10px;padding:20px;color:var(--muted)}
.cs-bad{color:#ffb4ac;border-color:#5a2a26}
.cs-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(220px,1fr));gap:16px}
.cs-card{background:var(--panel);border:1px solid var(--line);border-radius:12px;overflow:hidden;display:flex;flex-direction:column}
.cs-thumb{height:120px;display:flex;align-items:center;justify-content:center;font-size:52px;
  background:radial-gradient(circle at 50% 40%,#232a36,#12151b)}
.cs-card-body{padding:14px}
.cs-card-name{font-weight:700;font-size:16px}
.cs-card-author{color:var(--muted);font-size:13px;margin-bottom:12px}
.cs-btn{width:100%;background:var(--accent);color:#111;border:none;border-radius:8px;padding:9px;font-weight:700;cursor:pointer;font-size:14px}
.cs-btn:hover{filter:brightness(1.08)}
.cs-id{color:var(--muted);font-size:11px;margin-top:8px;font-family:ui-monospace,Consolas,monospace}
@media(max-width:520px){.cs-play-main{padding:20px 16px}.cs-play-main h1{font-size:24px}}
`;
